import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axiosIns from '@/axios'
import store from '@/store'
import { useRouter } from '@/@core/utils/utils'

export default function useEventsHourly() {
  // Use toast
  const toast = useToast()
  const { route } = useRouter()

  const refUserListTable = ref(null)
  const isFenomen = store.getters['user/isFenomen']
  // Table Columns
  const tableColumns = [
    { key: 'created_date', label: 'Paylaşım Tarihi', sortable: true },
    { key: 'link', label: 'Paylaşım', sortable: true },
    { key: 'total_visits', label: 'Ziyaret Sayısı', sortable: true, tdClass: "text-center", thClass: "text-center" },
    { key: 'show_details', label: 'Saatlik Bilgi'},
  ]

  if (!isFenomen && route.value.params.type === 'influencer') {
    tableColumns.splice(1, 0, { key: 'influencer', label: 'Fenomen', sortable: true })
  }else{
    tableColumns.splice(1, 0, { key: 'platform', label: 'Platform', sortable: true })
    tableColumns.splice(1, 0, { key: 'type', label: 'Kaynak', sortable: true })
  }
  

  const perPage = ref(store.state.appConfig.perPage)
  const totalEvents = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('created_date')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEvents.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, () => route.value.params] , () => {
    refetchData()
  })
  

  const fetchEvents = (ctx, callback) => {
    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      typeOf: route.value.params.type
    }

    axiosIns
      .get('/eventNew', { params })
      .then(response => {
        const { Events, total } = response.data.data
        callback(Events)
        totalEvents.value = total
      })
      .catch(error => {
        if (!error.response || error.response.status !== 401) {
          toast({
            component: ToastificationContent,
            props: {
              title: error.response.data.error,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
  }

  return {
    fetchEvents,
    tableColumns,
    perPage,
    currentPage,
    totalEvents,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,
    refetchData,
  }
}
